import React from "react";
import { componentes_routes } from "../routers";
import { messageError, validaMessagesErrors } from "./messageConfig";
import { parseNumeric } from "./utils";
import * as Icons from "@ant-design/icons";
import { Link } from "react-router-dom";
const fn_CalculoTotales_Item = ({
  preciounitario,
  cantidad,
  descuentos = 0,
  porcentajeigv,
}) => {
  porcentajeigv = parseNumeric(porcentajeigv);
  const valorunitario = parseNumeric(
    preciounitario / (1 + porcentajeigv / 100)
  );
  const valorigvunitario = parseNumeric((valorunitario * porcentajeigv) / 100);
  const valorigv = parseNumeric(cantidad * valorigvunitario);
  const valorventabruto = parseNumeric(valorunitario * cantidad);
  const valorventa = parseNumeric(cantidad * preciounitario - descuentos);
  const totalventa = parseNumeric(cantidad * preciounitario);
  return {
    valorunitario,
    valorigvunitario,
    valorigv,
    valorventabruto,
    valorventa,
    totalventa,
  };
};
const getItem = (label, key, icon, children = []) => {
  return {
    key,
    icon,
    children,
    label,
  };
};
export const getMenuItems = (routesFilter, rutapadre = null) => {
  let menu_items = [];
  let submenu_keys = [];
  routesFilter
    .filter((x) => x.rutapadre === rutapadre)
    .forEach((item) => {
      let haveChildrens =
        routesFilter.filter((x) => x.rutapadre === item.id).length > 0
          ? true
          : false;
      const _key = item.path.startsWith("/") ? item.path.slice(1) : item.path;
      let _icon = null;
      let _children = null;

      if (haveChildrens) {
        const data = getMenuItems(routesFilter, item.id);
        _icon = item.icono && React.createElement(Icons[item?.icono]);
        _children = data?.menu_items;
        submenu_keys = [...submenu_keys, _key];
      }
      const MenuItem = getItem(
        item.eslink ? <Link to={item.path}>{item.nombre}</Link> : item.nombre,
        _key,
        _icon,
        _children
      );
      menu_items = [...menu_items, MenuItem];
    });
  return { menu_items, submenu_keys };
};

const buildFullPaths = (data) => {
  const mapById = Object.fromEntries(data.map((item) => [item.id, item]));
  let result = [];

  const getFullPath = (item) => {
    if (!item.rutapadre) return item.path;
    const parent = mapById[item.rutapadre];
    return parent
      ? `${getFullPath(parent)}${item.path.startsWith("/") ? "" : "/"}${
          item.path
        }`
      : item.path;
  };

  result = data?.map((item) => ({ ...item, path: getFullPath(item) }));
  return result;
};

const get_routes_and_sidernav_by_usuario_and_empleado = (
  usuario,
  es_empleado
) => {
  let accesos_usuario = [];
  try {
    if (es_empleado) {
      if (!usuario?.is_superuser) {
        //Si el usuario esta asociado a un empleado
        accesos_usuario = usuario?.accesosusuario_login?.map((item) => ({
          ...item.ruta,
        }));
        if (accesos_usuario?.length === 0) {
          messageError("El usuario no tiene asociado ningún permiso");
        }
      } else {
        //Es un empleado y superusuario
        accesos_usuario = usuario?.accesosusuario_login;
      }
    } else {
      if (usuario?.is_superuser) {
        accesos_usuario = componentes_routes?.filter(
          (x) => x?.initialConfig === true && x.eslink === true
        );
      }
    }
    const accesos_paths = buildFullPaths(accesos_usuario);
    const menus_paths = accesos_paths?.filter((x) => x.esvisible === true);
    const routers = accesos_paths?.filter(
      (x) => x.eslink === true && x.componente !== null
    );

    const { menu_items, submenu_keys } = getMenuItems(menus_paths);
    return { menu_items, submenu_keys, routers };
  } catch (error) {
    validaMessagesErrors(error);
  }
};
const getLastPath = () => localStorage.getItem("lastPath") || "/";
const setLastPath = (path) => localStorage.setItem("lastPath", path);
const hasValidSession = () => {
  const tokens = localStorage.getItem("authTokens");
  return !!tokens;
};

export {
  fn_CalculoTotales_Item,
  get_routes_and_sidernav_by_usuario_and_empleado,
  getLastPath,
  setLastPath,
  hasValidSession,
};
